<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalSenha">
        <div class="modal-dialog modal-sm">
            <div class="modal-content">
                <div class="modal-header">
                    <p><i class="fa fa-lock"></i> {{$t('words.change_password')}}</p>
                    <a class="close" data-dismiss="modal" aria-hidden="true">×</a>
                </div>
                <div class="modal-body">
                    <!-- Senha Atual -->
                    <div class="form-group">
                            <required/>
                            {{$t('words.current_password')}}
                        
                        <input name="old_password" :class="{ 'is-invalid': errors.has('old_password') }" v-validate="{required:true}" v-model="usuario.old_password"
                            type="password" class="form-control" :placeholder="$t('words.type_current_password')">
                        <div class="invalid-feedback help-block error">{{errors.first('old_password')}}</div>
                    </div>
                    <!-- Nova Senha -->
                    <div class="form-group">                    
                            <required/>
                            {{$t('words.new_password')}}                        
                        <input name="password" :class="{ 'is-invalid': errors.has('password') }" type="password" class="form-control" v-model="usuario.password"
                            v-validate="'required|min:6'" :placeholder="$t('words.type_new_password')">
                        <div class="invalid-feedback help-block error">{{errors.first('password')}}</div>
                    </div>
                    <!-- Confirma Senha -->
                    <div class="form-group">                    
                            <required/>
                            {{$t('words.confirm_new_password')}}                        
                        <input name="password_confirmation" :class="{ 'is-invalid': errors.has('password_confirmation') }" type="password" class="form-control"
                            v-model="usuario.password_confirmation" v-validate="'required'"
                            :placeholder="$t('words.type_confirm_new_password')">
                        <div class="invalid-feedback help-block error">{{errors.first('password_confirmation')}}</div>
                    </div>

                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-default float-left" data-dismiss="modal">
                        <i class="fa fa-times"></i>
                        {{$t('words.cancel')}}
                    </button>
                    <button type="button" :disabled="loading" @click="changePassword()"
                        class="btn btn-success">
                        <i class="fa fa-check"></i>
                        {{$t('words.save')}}
                        <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                usuario: {
                    old_password: '',
                    password: '',
                    password_confirmation: '',
                }
            }
        },
        methods: {
            changePassword() {
                this.$validator
                    .validateAll(['password', 'old_password', 'password_confirmation'])
                    .then(valid => {
                        if (valid) {
                            this.loading = true;
                            let obj = {
                                old_password: this.usuario.old_password,
                                password: this.usuario.password,
                                password_confirmation: this.usuario.password_confirmation,
                            };
                            this.$store
                                .dispatch('changePassword', obj)
                                .then(response => {
                                    this.loading = false;
                                    if (response.status === 'success') {
                                        toastr({
                                            icon: response.status,
                                            title: response.message
                                        });
                                        this.prepareModalPassword();
                                    }
                                });
                        }
                    });
            },
            resetFormModal() {
                this.usuario.old_password = null;
                this.usuario.password = null;
                this.usuario.password_confirmation = null;
                this.$validator.reset();
            },
            prepareModalPassword() {
                this.resetFormModal();
                $('#ModalSenha').modal('toggle');
            },
        }
    };
</script>